export default "__VITE_ASSET__B1lL3vSS__"